import { CheckCircle } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconCheckCircle12Line = createIcon(CheckCircle, 12, "Line");
export const IconCheckCircle16Line = createIcon(CheckCircle, 16, "Line");
export const IconCheckCircle20Line = createIcon(CheckCircle, 20, "Line");
export const IconCheckCircle24Line = createIcon(CheckCircle, 24, "Line");
export const IconCheckCircle32Line = createIcon(CheckCircle, 32, "Line");
export const IconCheckCircle48Line = createIcon(CheckCircle, 48, "Line");
export const IconCheckCircle64Line = createIcon(CheckCircle, 64, "Line");
